// Stall bookkeeping (IMPLEMENTATION §0.5 stalls.json, §2.4 phase 7). Systems raise and clear stalls; the
// progress phase announces a stall once it has lasted `graceTicks` (one `stall` event per episode) and a
// cleared stall that was announced emits `unstall`. M2 uses VEIN_BLOCKED and NO_TARGET; M3 adds the rest.

import type { Int } from './core/types.ts';
import type { Ctx } from './ctx.ts';
import type { SimDefs } from './defs.ts';
import type { StallId } from './gen/ids.ts';
import type { Building } from './state.ts';

export function graceOf(d: SimDefs, id: StallId): Int {
  for (const x of d.stalls) if (x.id === id) return x.graceTicks;
  throw new RangeError(`unknown stall ${id}`);
}

function announced(d: SimDefs, b: Building): boolean {
  return b.stall !== null && b.stallT > graceOf(d, b.stall);
}

/** Starts a stall episode (no-op when the same stall is already running). */
export function raiseStall(c: Ctx, b: Building, id: StallId): void {
  if (b.stall === id) return;
  clearStall(c, b);
  b.stall = id;
  b.stallT = 0;
}

/** Ends the current episode; emits `unstall` when it had been announced. */
export function clearStall(c: Ctx, b: Building): void {
  if (b.stall === null) return;
  if (announced(c.d, b)) c.ev.push({ e: 'unstall', bid: b.id, stall: b.stall });
  b.stall = null;
  b.stallT = 0;
}

/** Phase 7: grace transitions, in building id order. */
export function runStallTransitions(c: Ctx): void {
  for (const b of c.s.buildings) {
    if (b.stall === null) continue;
    const grace = graceOf(c.d, b.stall);
    if (b.stallT === grace) c.ev.push({ e: 'stall', bid: b.id, stall: b.stall });
    if (b.stallT <= grace) b.stallT += 1;
  }
}
